<template>
    <div class="card-box p-0 over_hide">
        <div class="header_items_dash">
            <div class="w_full">
                <h4 class="header-title m-t-0 m-b-7 text-dark t_overflow">{{ $t('email_interactions') }}</h4>
                <small class="show text-muted f_size_12 t_overflow">{{ $t('last_delivered_open_or_clicked_emails') }}</small>
            </div>
            <router-link :to="{ name: 'emails.index' }" class="btn btn-white btn-sm">{{ $t("show_all") }}</router-link>
        </div>
        <ul class="list_items_dash">
            <router-link v-for="item in list" tag="li" :to="`/deals/${item.deal.id}/emails`" :key="item.id">
                <div class="photo_lead">
                    <img :src="item.deal.lead.avatar || '/static/images/avatar.jpg'" title="Nome do Lead" class="img-circle thumb-sm">
                </div>
                <div class="w_full">
                    <div class="d_flex">
                        <p class="m-b-4 f_size_13 c_default w_full min_w_0">
                            <strong>#{{item.deal.code}}<span v-if="item.deal.lead.full_name !== item.deal.lead.email"> - {{item.deal.lead.full_name}}</span></strong>
                            <small class="show t_overflow text-muted" v-if="item.deal.lead.reference">({{item.deal.lead.reference}})</small>
                        </p>
                        <div class="text-center max_w_80">
                            <label class="label label-inverse m-0">{{$t(item.status)}}</label>
                        </div>
                        <small class="f_size_10 text-muted text-right max_w_60">{{ item.updated_at | pmlDate('DD/MM/YYYY HH:mm') }}</small>
                    </div>
                    <div class="d_flex">
                        <p class="w_full t_overflow f_size_12 m-0">{{item.subject}}</p>

                    </div>
                </div>
            </router-link>
            <PmlInfiniteLoading @infinite="infiniteHandler($event)" ref="infiniteLoading" spinner="wavedots">
                <span slot="no-more"></span>
                <span slot="no-results"></span>
                <span v-if="list.length === total && !isLoading" slot="spinner"></span>
            </PmlInfiniteLoading>
            <router-link :to="{ name: 'sent-emails.create' }" tag="li" class="null_item"  v-if="!list.length && !isLoading">
                <div class="clearfix text-center">
                    <div class="icon_svg m-b-5">
                        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 58 58" xml:space="preserve"><g><g><polygon points="0,5.146 0,44.146 28,44.146 56,44.146 56,5.146 " style="fill: rgb(199, 207, 226);"></polygon><path d="M30.965,27.253c-1.637,1.462-4.292,1.462-5.93,0l-2.087-1.843C16.419,31.238,0,44.146,0,44.146h21.607h12.787H56c0,0-16.419-12.909-22.948-18.736L30.965,27.253z" style="fill: rgb(225, 228, 239);"></path><path d="M0,5.146l25.035,22.107c1.637,1.462,4.292,1.462,5.93,0L56,5.146H0z" style="fill: rgb(239, 242, 250);"></path></g><g><polygon points="36.566,43.361 36.559,43.368 34.571,50.658 39.217,46.011 " style="fill: rgb(237, 220, 199);"></polygon><path d="M55.816,29.412l-1.247-1.247c-0.775-0.775-2.032-0.775-2.807,0l-3.582,3.582l2.651,2.651L55.816,29.412z" style="fill: rgb(215, 90, 74);"></path><rect x="41.824" y="30.667" transform="matrix(0.7071 0.7071 -0.7071 0.7071 40.2908 -19.5122)" width="3.749" height="16.424" style="fill: rgb(242, 156, 33);"></rect><polygon points="42.216,49.025 42.223,49.018 39.217,46.011 34.571,50.658 34.437,51.146 " style="fill: rgb(214, 196, 177);"></polygon><path d="M53.837,37.404l3.582-3.582c0.775-0.775,0.775-2.032,0-2.807l-1.602-1.602l-4.985,4.985L53.837,37.404z" style="fill: rgb(163, 71, 64);"></path><rect x="44.401" y="33.495" transform="matrix(-0.7071 -0.7071 0.7071 -0.7071 49.9343 104.099)" width="4.251" height="16.424" style="fill: rgb(225, 140, 37);"></rect><path d="M33.73,52.854c-0.256,0-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414l2.207-2.207c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414l-2.207,2.207C34.242,52.756,33.986,52.854,33.73,52.854z" style="fill: rgb(94, 94, 94);"></path></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>
                    </div>
                    <small class="show m-b-5">{{ $t('no_email_interaction_found') }}</small>
                    <p class="bold m-0 c_blue">{{ $t('send_an_email') }}</p>
                </div>
            </router-link>
        </ul>
    </div>
</template>

<script>
    import { getAllPaged } from '@/services/emails'
    import { mapGetters } from 'vuex'
    import PmlInfiniteLoading from 'vue-infinite-loading'
    import bus from 'utils/events/bus'

    export default {
        name: 'LastEmailInteractions',
        components: {
            PmlInfiniteLoading
        },
        data () {
            return {
                isLoading: true,
                list: [],
                page: 0,
                total: 0,
                paginate: 10
            }
        },
        computed: {
            ...mapGetters({
                'member': 'getMember'
            })
        },
        created () {
            bus.$on('refreshEmailsCard', this.clearInfinity)
        },
        methods: {
            getAllPaged ($state) {
                this.isLoading = true
                getAllPaged(
                    this.page + 1,
                    {
                        status_s: ['delivered', 'open', 'click'],
                        orderBy: 'updated_at',
                        paginate: this.paginate,
                        member_id: this.member.id,
                        relations: ['deal.lead'],
                        orderDirection: 'desc'
                    }
                )
                    .then((response) => {
                        this.list.push(...response.data.data)
                        this.page = response.data.current_page
                        this.total = response.data.total

                        $state.loaded()
                        if (this.list.length === this.total)
                            $state.complete()
                    })
                    .then(() => { this.isLoading = false })
            },
            infiniteHandler ($state) {
                setTimeout(() => {
                    this.getAllPaged($state)
                }, 1000)
            },
            clearInfinity () {
                this.isLoading = true
                this.list = []
                this.page = 0
                this.total = 0
                this.$nextTick(() => {
                    if (typeof this.$refs['infiniteLoading'] !== 'undefined')
                        this.$refs['infiniteLoading'].$emit('$InfiniteLoading:reset')
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/dashboard/components/widgets/LastEmailInteractions.vue